/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
 */
export interface JpCoBenefitoneBsSubsidyDtoGroupGetInfV2 {
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoGroupGetInfV2}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    tlementNo?: JpCoBenefitoneBsSubsidyDtoGroupGetInfV2;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoGroupGetInfV2}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    tingMethodDivCompany?: JpCoBenefitoneBsSubsidyDtoGroupGetInfV2;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    groupName?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    dispWebNm?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    payOffFrom?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    payOffTgtSubscriptionId?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    targetService?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    settingMethodDivCompany?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    subsidyType?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    receptionDateFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    receptionDateTo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    applicableDateFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    applicableDateTo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    settlementNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    usedIimTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    usedIimUnit?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    usedMaxCnt?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    usedMaxTotalAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    parsonalUsedMaxCnt?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    parsonalUsedMaxTotalAmt?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    usedExpectedAmt?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    yearEndDatetime?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    termType?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    dispMyPage?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoGroupGetInfV2
     */
    dispNoteComment?: string;
}

export function JpCoBenefitoneBsSubsidyDtoGroupGetInfV2FromJSON(json: any): JpCoBenefitoneBsSubsidyDtoGroupGetInfV2 {
    return JpCoBenefitoneBsSubsidyDtoGroupGetInfV2FromJSONTyped(json, false);
}

export function JpCoBenefitoneBsSubsidyDtoGroupGetInfV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsSubsidyDtoGroupGetInfV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tlementNo': !exists(json, 'tlementNo') ? undefined : JpCoBenefitoneBsSubsidyDtoGroupGetInfV2FromJSON(json['tlementNo']),
        'tingMethodDivCompany': !exists(json, 'tingMethodDivCompany') ? undefined : JpCoBenefitoneBsSubsidyDtoGroupGetInfV2FromJSON(json['tingMethodDivCompany']),
        'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
        'groupName': !exists(json, 'groupName') ? undefined : json['groupName'],
        'dispWebNm': !exists(json, 'dispWebNm') ? undefined : json['dispWebNm'],
        'payOffFrom': !exists(json, 'payOffFrom') ? undefined : json['payOffFrom'],
        'payOffTgtSubscriptionId': !exists(json, 'payOffTgtSubscriptionId') ? undefined : json['payOffTgtSubscriptionId'],
        'targetService': !exists(json, 'targetService') ? undefined : json['targetService'],
        'settingMethodDivCompany': !exists(json, 'settingMethodDivCompany') ? undefined : json['settingMethodDivCompany'],
        'subsidyType': !exists(json, 'subsidyType') ? undefined : json['subsidyType'],
        'receptionDateFrom': !exists(json, 'receptionDateFrom') ? undefined : json['receptionDateFrom'],
        'receptionDateTo': !exists(json, 'receptionDateTo') ? undefined : json['receptionDateTo'],
        'applicableDateFrom': !exists(json, 'applicableDateFrom') ? undefined : json['applicableDateFrom'],
        'applicableDateTo': !exists(json, 'applicableDateTo') ? undefined : json['applicableDateTo'],
        'settlementNo': !exists(json, 'settlementNo') ? undefined : json['settlementNo'],
        'usedIimTerm': !exists(json, 'usedIimTerm') ? undefined : json['usedIimTerm'],
        'usedIimUnit': !exists(json, 'usedIimUnit') ? undefined : json['usedIimUnit'],
        'usedMaxCnt': !exists(json, 'usedMaxCnt') ? undefined : json['usedMaxCnt'],
        'usedMaxTotalAmt': !exists(json, 'usedMaxTotalAmt') ? undefined : json['usedMaxTotalAmt'],
        'parsonalUsedMaxCnt': !exists(json, 'parsonalUsedMaxCnt') ? undefined : json['parsonalUsedMaxCnt'],
        'parsonalUsedMaxTotalAmt': !exists(json, 'parsonalUsedMaxTotalAmt') ? undefined : json['parsonalUsedMaxTotalAmt'],
        'usedExpectedAmt': !exists(json, 'usedExpectedAmt') ? undefined : json['usedExpectedAmt'],
        'yearEndDatetime': !exists(json, 'yearEndDatetime') ? undefined : json['yearEndDatetime'],
        'termType': !exists(json, 'termType') ? undefined : json['termType'],
        'dispMyPage': !exists(json, 'dispMyPage') ? undefined : json['dispMyPage'],
        'dispNoteComment': !exists(json, 'dispNoteComment') ? undefined : json['dispNoteComment'],
    };
}

export function JpCoBenefitoneBsSubsidyDtoGroupGetInfV2ToJSON(value?: JpCoBenefitoneBsSubsidyDtoGroupGetInfV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tlementNo': JpCoBenefitoneBsSubsidyDtoGroupGetInfV2ToJSON(value.tlementNo),
        'tingMethodDivCompany': JpCoBenefitoneBsSubsidyDtoGroupGetInfV2ToJSON(value.tingMethodDivCompany),
        'groupId': value.groupId,
        'groupName': value.groupName,
        'dispWebNm': value.dispWebNm,
        'payOffFrom': value.payOffFrom,
        'payOffTgtSubscriptionId': value.payOffTgtSubscriptionId,
        'targetService': value.targetService,
        'settingMethodDivCompany': value.settingMethodDivCompany,
        'subsidyType': value.subsidyType,
        'receptionDateFrom': value.receptionDateFrom,
        'receptionDateTo': value.receptionDateTo,
        'applicableDateFrom': value.applicableDateFrom,
        'applicableDateTo': value.applicableDateTo,
        'settlementNo': value.settlementNo,
        'usedIimTerm': value.usedIimTerm,
        'usedIimUnit': value.usedIimUnit,
        'usedMaxCnt': value.usedMaxCnt,
        'usedMaxTotalAmt': value.usedMaxTotalAmt,
        'parsonalUsedMaxCnt': value.parsonalUsedMaxCnt,
        'parsonalUsedMaxTotalAmt': value.parsonalUsedMaxTotalAmt,
        'usedExpectedAmt': value.usedExpectedAmt,
        'yearEndDatetime': value.yearEndDatetime,
        'termType': value.termType,
        'dispMyPage': value.dispMyPage,
        'dispNoteComment': value.dispNoteComment,
    };
}

